// Color helpers for theme derivation — shared by AppearanceTab and PublicPage
export const hexToRgb = (h) => {
  const m = (h || "").replace("#", "");
  if (m.length !== 6) return [0, 0, 0];
  return [parseInt(m.slice(0, 2), 16), parseInt(m.slice(2, 4), 16), parseInt(m.slice(4, 6), 16)];
};

export const rgbToHex = (r, g, b) =>
  "#" + [r, g, b].map((v) => Math.max(0, Math.min(255, Math.round(v))).toString(16).padStart(2, "0")).join("");

// mix color a toward color b by weight w (0..1)
export const mix = (a, b, w) => {
  const A = hexToRgb(a);
  const B = hexToRgb(b);
  return rgbToHex(A[0] + (B[0] - A[0]) * w, A[1] + (B[1] - A[1]) * w, A[2] + (B[2] - A[2]) * w);
};

export const deriveFromAccent = (accent) => ({
  accent,
  accent_light: mix(accent, "#FFFFFF", 0.55),
});

export const deriveFromBg = (bg) => ({
  bg,
  bg_alt: mix(bg, "#000000", 0.35),
  surface: mix(bg, "#FFFFFF", 0.07),
  text: "#F6F4FA",
  muted: mix(bg, "#FFFFFF", 0.62),
});
